/* One collapsed section of Compose Email on a phone: icon, title, a one-line
   summary of what is inside, an optional count, and the body it opens.

   Tapping the head toggles; taps that land inside the body are ignored, so
   working in the form doesn't collapse the section under your finger. */
export default function ComposeBlock({ icon, title, summary, flag, flagTone, open, onToggle, children }) {
  return (
    <div className={`mblock ${open ? 'open' : ''}`}>
      <div
        className="mhead"
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <span className="ic">{icon}</span>
        <span className="tx">
          <b>{title}</b>
          <span>{summary}</span>
        </span>
        {flag !== undefined && flag !== null && (
          <span className={`mflag ${flagTone || ''}`}>{flag}</span>
        )}
        <svg className="cv" viewBox="0 0 24 24"><path d="m9 6 6 6-6 6" /></svg>
      </div>
      <div className="mbody">{children}</div>
    </div>
  );
}
